import React, { useContext, useEffect, useState } from 'react';
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { PaginatorContext } from '../../../providers/Paginator';
import { Table, TablePagination, TableBody, Paper, Menu, TableContainer, TableHead, TableRow, TableCell, CircularProgress, IconButton, MenuItem, CardMedia, Chip, TextField, InputAdornment } from "@mui/material";
import useCompras from './useCompras';
import empty from "../../../assets/empty.png";
import moment from 'moment';
import { CalendarTodayOutlined, ChevronLeft, ChevronRight, ConfirmationNumberOutlined, FirstPage, KeyboardArrowDown, KeyboardArrowUp, LastPage, MoreVert, ReceiptLongOutlined, Search } from '@mui/icons-material';
import { useMediaQuery } from "react-responsive";
moment.locale('es');

const Compras = () => {
  const {
    setCurrentPage,
    setPageSize,
  } = useContext(PaginatorContext);
  const history = useHistory();
  const [searchTerm, setSearchTerm] = useState("");
  const [tempSearchTerm, setTempSearchTerm] = useState("");
  const { compras, loading, total, onSearch, pagination, setPagination } = useCompras();
  const isMobile = useMediaQuery({ query: `(max-width: 770px)` });
  const [menuState, setMenuState] = useState({
    anchorEl: null,
    selectedCompraId: null, // Agrega el id de la compra seleccionada
  });

  const open = Boolean(menuState.anchorEl);

  const handleClick = (event, id) => {
    setMenuState({
      anchorEl: event.currentTarget, // Elemento anclado
      selectedCompraId: id, // ID de la compra
    });
  };

  const handleClose = () => {
    setMenuState({
      anchorEl: null,
      selectedCompraId: null, // Resetea el id seleccionado
    });
  };

  // Manejar el cambio de página
  const handleChangePage = (event, newPage) => {
    setPagination(prev => ({
      ...prev,
      current: newPage,
    }))
  };

  // Manejar el cambio de tamaño de página
  const handleChangeRowsPerPage = (event) => {
    const newSize = parseInt(event.target.value, 10);
    setPagination(prev => ({
      ...prev,
      pageSize: newSize,
      current: 0,
    }));
  };

  const handleSearchChange = (e) => {
    setTempSearchTerm(e.target.value);
  }
  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      executeSearch();
    }
  }

  const executeSearch = () => {
    setSearchTerm(tempSearchTerm);
    onSearch(tempSearchTerm);
  }

  useEffect(() => {
    setTempSearchTerm(searchTerm);
  }, []);

  useEffect(() => {
    if (pagination) {
      setCurrentPage(pagination.current);
      setPageSize(pagination.pageSize);
    }
  }, [pagination, setCurrentPage, setPageSize]);

  const [expandedId, setExpandedId] = useState(null);

  const toggleExpand = (id) => {
    setExpandedId(expandedId === id ? null : id);
  };

  return (
    <div className="container-fluid" style={{ padding: "20px 8%" }}>
      <p className='mt-3 mb-1' style={{ color: "#0B0060", fontSize: "28px", fontWeight: "600" }}>Mis compras</p>
      <span className='' style={{ color: '#71717A' }}>Aquí vas a encontrar todas tus compras. Hacé clic en cada una para acceder a tu ticket.</span>
      <div className='my-4'>
        <TextField
          placeholder='Buscar compra por evento...'
          variant='outlined'
          value={tempSearchTerm}
          onChange={handleSearchChange}
          onKeyDown={handleKeyDown}
          sx={{
            maxWidth: '600px',
            width: '100%',
            '& .MuiOutlinedInput-root': {
              height: '40px !important',
              '& fieldset': {
                borderColor: '#B5BABF',
              },
              '&:hover fieldset': {
                borderColor: '#0B0060',
              },
              '&.Mui-focused fieldset': {
                borderColor: '#0B0060',
              },
            },
          }}
          slotProps={{
            input: {
              startAdornment: (
                <InputAdornment position="start">
                  <IconButton size='small' onClick={executeSearch} sx={{ marginLeft: "-8px" }}>
                    <Search sx={{ color: '#6B7280' }} />
                  </IconButton>
                </InputAdornment>
              ),
            }
          }}
        />
      </div>
      <div>
        {compras?.length > 0 ? (
          <>
            {isMobile ? (
              <>
                <div className="mt-3">
                  {loading ? (
                    <div className="d-flex justify-content-center my-4">
                      <CircularProgress />
                    </div>
                  ) : (
                    compras.map((compra) => (
                      <div
                        key={compra.id}
                        className="card mb-3"
                        style={{ borderRadius: '8px', border: '1px solid #E0E0E0' }}
                      >
                        <div
                          className="card-body p-3"
                          onClick={() => toggleExpand(compra.id)}
                          style={{ cursor: 'pointer' }}
                        >
                          <div className="d-flex position-relative align-items-center" style={{ width: '100%' }}>
                            <div style={{ marginRight: '10px', flexShrink: 0 }}>
                              {expandedId === compra.id ?
                                <KeyboardArrowUp sx={{ color: "#5656ff" }} />
                                :
                                <KeyboardArrowDown sx={{ color: "#5656ff" }} />
                              }
                            </div>

                            <div style={{
                              maxWidth: 'calc(100% - 95px)',
                              color: "#0b0060",
                              fontFamily: "Bricolage Grotesque",
                              fontWeight: 500,
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                              paddingRight: "10px"
                            }}>
                              {compra.carrito?.evento?.evento}
                            </div>

                            <div style={{
                              position: 'absolute',
                              right: 0,
                              fontWeight: 'bold',
                              color: "#0b0060",
                              fontFamily: "Bricolage Grotesque",
                              minWidth: "60px",
                              textAlign: 'right',
                            }}>
                              {" "}$ {compra.monto_total}
                            </div>
                          </div>

                          {expandedId === compra.id && (
                            <div className="mt-3 pt-3" style={{ borderTop: '1px solid #E6E6FF' }}>
                              <div className="col g-3">
                                <div className="">
                                  <div className="d-flex align-items-center flex-row justify-content-between">
                                    <span>Fecha de compra: </span>
                                    <div>
                                      <CalendarTodayOutlined sx={{ width: "16px", height: "16px", color: "#5656FF", marginRight: "8px" }} />
                                      <span style={{ fontSize: '14px', color: '#525252', fontFamily: "Bricolage Grotesque" }}>
                                        {moment(compra.atendido).clone().local().format("DD/MM/YYYY")}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div className="mt-3">
                                  <div className="d-flex justify-content-between align-items-center flex-row">
                                    <span>Estado: </span>
                                    <Chip
                                      size="small"
                                      label={compra.atendido ? "Aprobada" : "Pendiente"}
                                      sx={{
                                        backgroundColor: !compra.atendido ? '#FFEFC2' : '#B6FECB',
                                        color: !compra.atendido ? '#7A4E00' : '#216735',
                                        fontSize: '12px',
                                        height: '24px',
                                        fontFamily: "Bricolage Grotesque"
                                      }}
                                    />
                                  </div>
                                </div>
                              </div>

                              {compra.atendido && (
                                <div className="d-flex w-100 mt-3">
                                  <button
                                    className="btn w-100 me-2"
                                    style={{
                                      backgroundColor: '#E6E6FF',
                                      color: '#5656ff',
                                      borderRadius: '6px',
                                      fontSize: '14px',
                                      fontFamily: "Bricolage Grotesque"
                                    }}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      history.push(`/compra/${compra.id}`);
                                    }}
                                  >
                                    <ConfirmationNumberOutlined sx={{ fontSize: '14px', marginRight: '4px' }} />
                                    Ver tickets
                                  </button>
                                  <button
                                    className="btn w-100"
                                    style={{
                                      backgroundColor: 'transparent',
                                      borderColor: '#8E8EFF',
                                      color: '#5656FF',
                                      borderRadius: '6px',
                                      fontSize: '14px',
                                      fontFamily: "Bricolage Grotesque"
                                    }}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      history.push(`/compra/${compra.id}/recibo`);
                                    }}
                                  >
                                    <ReceiptLongOutlined sx={{ fontSize: '14px', marginRight: '4px' }} />
                                    Ver recibo
                                  </button>
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                    ))
                  )}

                  <div className="d-flex justify-content-between align-items-center my-3">
                    <div className="d-flex align-items-center">
                      <select
                        className="form-select form-select-sm"
                        style={{
                          width: 'auto',
                          marginRight: '8px',
                          borderColor: '#E6E6FF',
                          color: '#0B0060',
                          fontSize: '14px',
                          fontFamily: 'Bricolage Grotesque'
                        }}
                        value={pagination?.pageSize || 10}
                        onChange={(e) => handleChangeRowsPerPage(e)}
                      >
                        {[10, 25, 50].map(size => (
                          <option key={size} value={size}>{size}</option>
                        ))}
                      </select>
                      {/* <span style={{
                        fontSize: '14px',
                        color: '#71717A',
                        fontFamily: 'Bricolage Grotesque'
                      }}>
                        por pág
                      </span> */}
                    </div>

                    <div className="d-flex align-items-center">
                      <div>
                        <IconButton
                          onClick={(e) => handleChangePage(e, 0)}
                          disabled={pagination.current === 0}
                          size="small"
                          sx={{
                            padding: '4px',
                            color: pagination.current === 0 ? '#B5BABF' : '#0B0060',
                            '&:hover': {
                              backgroundColor: '#F5F5FF'
                            }
                          }}
                        >
                          <FirstPage fontSize="small" />
                        </IconButton>
                        <IconButton
                          onClick={(e) => handleChangePage(e, pagination.current - 1)}
                          disabled={pagination.current === 0}
                          size="small"
                          sx={{
                            padding: '4px',
                            color: pagination.current === 0 ? '#B5BABF' : '#0B0060',
                            '&:hover': {
                              backgroundColor: '#F5F5FF'
                            }
                          }}
                        >
                          <ChevronLeft fontSize="small" />
                        </IconButton>
                        <IconButton
                          onClick={(e) => handleChangePage(e, pagination.current + 1)}
                          disabled={pagination.current >= Math.ceil(total / pagination.pageSize) - 1}
                          size="small"
                          sx={{
                            padding: '4px',
                            color: pagination.current >= Math.ceil(total / pagination.pageSize) - 1 ? '#B5BABF' : '#0B0060',
                            '&:hover': {
                              backgroundColor: '#F5F5FF'
                            }
                          }}
                        >
                          <ChevronRight fontSize="small" />
                        </IconButton>
                        <IconButton
                          onClick={(e) => handleChangePage(e, Math.max(0, Math.ceil(total / pagination.pageSize) - 1))}
                          disabled={pagination.current >= Math.ceil(total / pagination.pageSize) - 1}
                          size="small"
                          sx={{
                            padding: '4px',
                            color: pagination.current >= Math.ceil(total / pagination.pageSize) - 1 ? '#B5BABF' : '#0B0060',
                            '&:hover': {
                              backgroundColor: '#F5F5FF'
                            }
                          }}
                        >
                          <LastPage fontSize="small" />
                        </IconButton>

                      </div>
                    </div>
                    <div className="d-flex align-items-center">
                      <span style={{
                        fontSize: '14px',
                        marginLeft: '12px',
                        color: '#71717A',
                        fontFamily: 'Bricolage Grotesque'
                      }}>
                        {total > 0 ? `${pagination.current * pagination.pageSize + 1}-${Math.min((pagination.current + 1) * pagination.pageSize, total)} de ${total}` : '0-0 de 0'}
                      </span>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <>
                <TableContainer component={Paper} className="mt-3">
                  <Table aria-label="simple table">
                    <TableHead sx={{ backgroundColor: "#E6E6FF" }}>
                      <TableRow sx={{ borderColor: "#E6E6FF" }}>
                        <TableCell sx={{ fontSize: "16px", fontWeight: "600", color: "#0B0060", fontFamily: "Bricolage Grotesque" }}>Evento</TableCell>
                        <TableCell sx={{ fontSize: "16px", fontWeight: "600", color: "#0B0060", fontFamily: "Bricolage Grotesque" }} align="center">Estado</TableCell>
                        <TableCell sx={{ fontSize: "16px", fontWeight: "600", color: "#0B0060", fontFamily: "Bricolage Grotesque" }} align="center">Fecha de compra</TableCell>
                        <TableCell sx={{ fontSize: "16px", fontWeight: "600", color: "#0B0060", fontFamily: "Bricolage Grotesque" }} align="center">Monto total</TableCell>
                        <TableCell></TableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {loading ? (
                        <TableRow>
                          <TableCell colSpan={5} align="center">
                            <CircularProgress />
                          </TableCell>
                        </TableRow>
                      ) : (
                        compras?.map((compra) => (
                          <TableRow
                            key={compra.id}
                            onDoubleClick={() => history.push(`/compra/${compra.id}`)}
                          >
                            <TableCell className="fw-medium fs-6" sx={{ fontFamily: "Bricolage Grotesque", color: "#0b0060" }}>
                              {compra.carrito?.evento?.evento}
                            </TableCell>

                            <TableCell align="center">
                              <Chip
                                size="small"
                                label={compra.atendido ? "Aprobada" : "Pendiente"}
                                sx={{
                                  backgroundColor: !compra.atendido ? '#FFEFC2' : '#B6FECB',
                                  color: !compra.atendido ? '#7A4E00 ' : '#216735',
                                  fontFamily: "Bricolage Grotesque"
                                }}
                              />
                            </TableCell>

                            <TableCell sx={{ fontFamily: "Bricolage Grotesque" }}>
                              <div className="d-flex justify-content-center align-items-center gap-2" >
                                <CalendarTodayOutlined sx={{ width: "18px", height: "18px", color: "#5656FF" }} />
                                {moment(compra.atendido).clone().local().format("DD/MM/YYYY")}
                              </div>
                            </TableCell>

                            <TableCell align="center" className="fw-semibold" sx={{ fontFamily: "Bricolage Grotesque" }}>
                              $ {compra.monto_total}
                            </TableCell>

                            <TableCell align="center">
                              {compra.atendido &&
                                <>
                                  <IconButton
                                    className="m-0"
                                    aria-label="see more"
                                    aria-expanded="true"
                                    aria-haspopup="true"
                                    onClick={(e) => handleClick(e, compra.id)}
                                  >
                                    <MoreVert />
                                  </IconButton>
                                  <Menu
                                    aria-label="report"
                                    anchorEl={menuState.anchorEl ?? undefined}
                                    open={open}
                                    onClose={handleClose}
                                    sx={{
                                      '& .MuiPaper-root': {
                                        boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.15)',
                                        borderRadius: '5px',
                                      },
                                      '& .MuiMenuItem-root': {
                                        fontFamily: 'Bricolage Grotesque',
                                        fontSize: '16px',
                                        padding: '8px 16px',
                                      }
                                    }}
                                  >
                                    <MenuItem
                                      onClick={() => {
                                        handleClose();
                                        history.push(`/compra/${menuState.selectedCompraId}`);
                                      }}
                                    >
                                      <ConfirmationNumberOutlined sx={{ marginRight: "10px", color: "#5656ff" }} />
                                      Ver tickets
                                    </MenuItem>
                                    <MenuItem
                                      onClick={() => {
                                        handleClose();
                                        history.push(`/compra/${menuState.selectedCompraId}/recibo`);
                                      }}
                                    >
                                      <ReceiptLongOutlined sx={{ marginRight: "10px", color: "#5656ff" }} />
                                      Ver recibo
                                    </MenuItem>
                                  </Menu>
                                </>
                              }
                            </TableCell>
                          </TableRow>
                        )
                        ))}
                    </TableBody>
                  </Table>

                  <TablePagination
                    component="div"
                    className="d-flex justify-content-center"
                    rowsPerPageOptions={[10, 25, 50]}
                    count={total || 0}
                    rowsPerPage={pagination?.pageSize || 0}
                    page={pagination?.current || 0}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    labelRowsPerPage="Registros p/página"
                    showFirstButton
                    showLastButton
                  />
                </TableContainer>
              </>
            )}
          </>
        ) : (
          <>
            <div className="d-flex flex-column align-items-center">
              <CardMedia
                component="img"
                sx={{ width: 200 }}
                image={empty}
                alt="Empty"
              />
              <small className="text-secondary">
                No tienes compras realizadas.
              </small>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Compras;